import type { PlStatementQuery } from '@/api/map/plStatement'

export const keys = {
  plStatement: (query: PlStatementQuery) => ['pl-statement', query] as const,
  /**
   * Lab Net total amount — CM-API `POST /v1/account/getDownlineAccountsSumOnly`.
   * Keyed on filters only (no page) so pagination does not re-hit the footer API.
   */
  plStatementSumOnly: (query: {
    from: string
    to: string
    q?: string
    tms?: string
    nameId?: string
    game?: string
    subGame?: string
    eventName?: string
    typeName?: string
    memberIds?: string[]
  }) => ['pl-statement-sum-only', query] as const,
  allTm: ['all-tm'] as const,
  siteUrl: ['member-site-url'] as const,
  games: ['games'] as const,
  subGames: (game: string) => ['sub-games', game] as const,
  eventsForPll: (query: {
    from: string
    to: string
    game?: string
    subGame?: string
    memberIds?: string[]
    tms?: string
    nameId?: string
  }) => ['events-for-pll', query] as const,
  memberBalance: ['member-balance'] as const,
  oneAccount: (id: string) => ['one-account', id] as const,
  searchHierarchyNew: (query: { filter: string; page?: number }) =>
    ['search-hierarchy-new', query] as const,
  searchHierarchyPage: (query: {
    filter: string[]
    page: number
    serchById: boolean
  }) => ['search-hierarchy-page', query] as const,
  reportScopeAccount: (id: string) => ['report-scope-account', id] as const,
  reportHierarchyTree: ['report-hierarchy-tree'] as const,
  reportHierarchySelf: ['report-hierarchy-self'] as const,
  myPnl: (query: {
    from: string
    to: string
    subGame: string
    eventId: string
    typeName: string
    page: number
    run: number
  }) => ['my-pnl', query] as const,
  myPnlGrandTotal: (query: {
    from: string
    to: string
    subGame: string
    eventId: string
    typeName: string
    run: number
  }) => ['my-pnl-grand-total', query] as const,
  myPnlEvents: (query: { from: string; to: string; subGame: string; run: number }) =>
    ['my-pnl-events', query] as const,
  myPnlMarkets: (query: {
    from: string
    to: string
    subGame: string
    eventId: string
    eventName: string
    typeName: string
    run: number
  }) => ['my-pnl-markets', query] as const,
  myPnlUsers: (query: {
    from: string
    to: string
    subGame: string
    eventId: string
    eventName: string
    typeName: string
    run: number
  }) => ['my-pnl-users', query] as const,
  commissionEligibility: (query: {
    tripleMaster?: string
    doubleMaster?: string
    superMaster?: string
    master?: string
    memberIds: string[]
    from: string
    to: string
    tab: string
    page: number
    pageSize: number
  }) => ['commission-eligibility', query] as const,
  commissionEventBets: (query: {
    from: string
    to: string
    playerId: string
    isEligible: boolean
  }) => ['commission-event-bets', query] as const,
  fancyBookmakerCommission: (query: {
    memberId: string
    childMemberId?: string
    from: string
    to: string
    searchNonce?: number
  }) => ['fancy-bookmaker-commission', query] as const,
  /** Member detail Net Exposure — Lab getPlayerBooksForBackend → getBooksForBackend. */
  playerBooks: (query: {
    playerId: string
    level?: string
    bookmakerSessionFlag?: string
  }) => ['player-books', query] as const,
  /** Member Net Exposure Details → getBetDetailsForWorkstation. */
  playerMarketBets: (query: { playerId: string; marketId: string }) =>
    ['player-market-bets', query] as const,
}
